export const TEXTS = {
  warningModalCalculateSquareMeter:
    'El área de los muros a pintar debe ser mayor al de puertas y/o ventanas. Aumenta el ancho o el alto de los muros o reduce la cantidad de puertas y/o ventanas.',
} as const;
